<template>
  <div class="page dialog-select">
    <header class="two-rows">
      <div>
        <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
        <div class="view-title">{{ buying.ticketInfo ? buying.ticketInfo.Title : ''}}</div>
      </div>
      <div v-if="!loading">
        <div v-if="what === 'origins'">{{ 'OriginSubtitle' | lang }}</div>
        <div v-else-if="what === 'travels'">{{ 'DestinationSubtitle' | lang }}</div>
        <div v-else-if="buying.ticketInfo.ItemLuggageVehicleWeightInfo">{{ buying.ticketInfo.ItemLuggageVehicleWeightInfo.ObjectType + '_title' | lang }}</div>
        <div class="floating-label" v-if="searchOptions.length > 5">
          <input v-model="searchString" placeholder=" " type="text" />
          <label>{{ 'filter' | lang }}</label>
        </div>
      </div>
    </header>
    <div v-if="loading"><div class="flexcentered bigger"><i class="fa fa-fw fa-refresh fa-spin"></i></div></div>
    <div v-scrolleffect v-else>
      <ul class="results">
        <li v-for="(opt, idx) in showOptions" :key="idx" @click="next(opt)" @keypress.space="next(opt)" tabindex="0" role="button">
          <div class="title">{{opt.Label}}</div>
          <div class="subtitle" v-if="opt.subtitle">{{ 'Through_travels_subtitle' | lang }} {{opt.subtitle}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import newProductParameterMixin from '@/mixins/newProductParameterMixin'

/*
OK - "origins" - origins
OK - "travels" - destinations
OK - "price" - price
        private const string LUGGAGE_VEHICLE_WEIGHT_KEY = "lvw";
OK - "additem" - /ignored/
*/

export default {
  name: 'NewProductParameter',
  mixins: [ page, newProductParameterMixin ],
  computed: {
    what () {
      return this.$route.params.what
    }
  },
  methods: {
    saveParameter (opt) {
      console.log('saveParameter', opt, this.what)
      switch (this.what) {
        case 'origins':
          this.buying = { ...this.buying, origin: opt }
          this.buying.ticketInfo.ItemOdTravelsInfo.Travel[0].Origin = opt
          break
        case 'travels':
          this.buying = { ...this.buying, destination: opt }
          this.buying.ticketInfo.ItemOdTravelsInfo.Travel[0] = opt.original
          break
        case 'price':
          this.buying.ticketInfo.Amount = opt.Price
          this.buying.ticketInfo.ItemOdTravelsInfo.Travel[0].Price = opt.Price
          break
        /* case 'via':
          this.buying = { ...this.buying, via: opt }
          this.buying.ticketInfo.ItemOdTravelsInfo.Travel[0] = opt.original
          break
        case 'viabis':
          this.buying = { ...this.buying, viabis: opt }
          this.buying.ticketInfo.ItemOdTravelsInfo.Travel[0] = opt.original
          break */
        case 'lvw':
          this.buying.ticketInfo.ItemLuggageVehicleWeightInfo.InfoLuggageWeightVehicle = { Description: opt.original.Description, FareIndex: opt.original.FareIndex }
          break
        default:
          alert(this.what + ' what?!')
      }
      let idx = this.buying.toBeAsked.indexOf(this.what)
      if (opt && opt.ApisToCall && opt.ApisToCall.length) {
        // this.buying.toBeAsked.splice(idx + 1, 0, ...opt.ApisToCall)
        opt.ApisToCall.forEach(step => {
          if (step === 'additem') {
            // ignore it
          } else if (step === 'price') {
            this.buying.askPrice = true
          } else {
            idx += 1
            this.buying.toBeAsked.splice(idx, 0, step)
          }
        })
      }
      // this.nextQuestion = this.buying.toBeAsked[idx + 1]
    },
    getData () {
      console.log('getData', this.what)
      switch (this.what) {
        case 'origins':
          return this._getOrigins(this.buying.ticketInfo, this.buying.csc ? this.buying.csc.MediaSerialNumber : null, this.buying.csc ? this.buying.csc.MediaUnicity : null)
        case 'travels':
          return this._getDestinations(this.buying.ticketInfo, this.buying.csc ? this.buying.csc.MediaSerialNumber : null, this.buying.csc ? this.buying.csc.MediaUnicity : null)
        case 'price':
          return this._getPrice(this.buying.ticketInfo, this.buying.csc ? this.buying.csc.MediaSerialNumber : null, this.buying.csc ? this.buying.csc.MediaUnicity : null)
                          .then(this.next)
        case 'lvw':
          return this._getLuggageVehicleWeightInfos(this.buying.ticketInfo, this.buying.csc ? this.buying.csc.MediaSerialNumber : null, this.buying.csc ? this.buying.csc.MediaUnicity : null)
        default:
          return new Promise((resolve, reject) => reject())
      }
      // return null
    }
  }
}
</script>

<style></style>
